import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S4-WB1
// (PRA-791), then standardized to a GET read route by PRA-818. The legacy
// `getEngagementLetterSecondGen` callable continues to exist in
// `cloudFunctions/` so any deployed firms-app build still holding the old
// route table can fall back to it; retirement of the callable export is
// deferred to S9-WB2.
export const getEngagementLetterRoute = {
  transport: 'api',
  method: 'GET',
  path: '/public/engagement-letters/:letterId',
  params: (requestData) => ({ letterId: requestData.letterId }),
  query: (requestData) => ({ firmId: requestData.firmId }),
} as const satisfies BackendRouteDefinition;
